import { isBrowser } from 'ws-scripts/modules/environment';

export const pauseWIAPIContent = async () => {
	window.dispatchEvent(new Event('pause-video'));
	return true;
};

export const resetWIAPIContent = async (selector) => {
	pauseWIAPIContent();

	// Reset WIAPI inserted content so things like videos don't play in the background when not visible.
	const galleryLocation =
		typeof selector === 'string'
			? document.querySelector(selector)
			: selector;

	if (!galleryLocation) {
		return;
	}

	// Remove API inserted HTML content
	galleryLocation
		.querySelectorAll('[data-wiapi-inserted-content]')
		.forEach((content) => {
			content.removeAttribute('data-wiapi-inserted-content');
			while (content.firstChild) {
				content.removeChild(content.lastChild);
			}
			content.remove();
		});

	// Put back placeholder content
	galleryLocation
		.querySelectorAll('[data-wiapi-placeholder-content]')
		.forEach((el) => {
			const elem = el;
			elem.style.display = 'block';
		});
};

export const replaceCarouselImageWithHTML = (wrapper, item) => {
	if (!isBrowser) {
		return;
	}

	const { src, html, callback, vehicle } = item;

	const callbackIsFunc = typeof callback === 'function';

	// We need HTML or a callback specified in order to proceed.
	if (!(html || callbackIsFunc)) {
		return;
	}

	// Get the insert location
	const images = wrapper.querySelectorAll(`
		.slick-slide > div > button > img[src="${src}"]
	`);

	// Image has already been replaced
	if (images.length === 0) {
		return;
	}

	images.forEach((image, index) => {
		const parent = image.parentElement;
		const height = image.clientHeight || parent.clientHeight;
		const width = image.clientWidth || parent.clientWidth;

		// Create the HTML node to insert
		const el = document.createElement('div');
		el.setAttribute('style', `height: ${height}px;`);
		el.setAttribute('data-wiapi-inserted-content', true);
		el.addEventListener('click', (e) => e.stopPropagation());

		if (html) {
			el.innerHTML = html;
		}

		// Append the HTML
		parent.appendChild(el);

		// Tag the image as a placeholder for later re-use
		image.setAttribute('data-wiapi-placeholder-content', true);

		// Hide the placeholder image for now
		// eslint-disable-next-line no-param-reassign
		image.style.display = 'none';

		parent.style['background-image'] = 'none';

		// Trigger the callback if specified
		if (callbackIsFunc && index === 0) {
			callback({
				el,
				locationId: 'carousel',
				height,
				width,
				vehicle
			});
		}
	});
};
